import apiClient from "./apiClient";

export const getAllSignups = async (page, per_page) => {
  try {
    const response = await apiClient.get(
      `/admin/list-signup?page=${page}&per_page=${per_page}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// api/signup.js
export const updateSignupStatus = async (signupId, status) => {
  try {
    const response = await apiClient.put(`/admin/signup/${signupId}`, { status });
    return response.data;
  } catch (error) {
    throw error;
  }
};
